export function iframeFunction() {
    let getCookie = (cookieName) => {
        let cookie = {};
        document.cookie.split(';').forEach(function (el) {
            let [key,value] = el.split('=');
            cookie[key.trim()] = value;
        });

        return cookie[cookieName];
    };
    let navRight = $('.sub-nav-right');

    let count = 0;
    let authlinktimer = window.setInterval(function () {
        let isLogin = getCookie('mt.is.authenticated.https%3A%2F%2Ffhittingroom.marianaiframes.com');

        if (count == 100 || isLogin) {
            navRight[`${isLogin ? 'add' : 'remove'}Class`]('enter');
            clearInterval( authlinktimer );
        }
        count++;
    }, 100);
}



// WEBPACK FOOTER //
// ./assets/js/modules/iframeFunction.js